import * as React from 'react';
import { cn } from '@discover-lib/utils';
import inputVariants, { type InputVariantProps } from './variants';

export type InputProps = React.ComponentPropsWithoutRef<'input'> & InputVariantProps;

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type = 'text', scale = 'md', ...props }, ref) => (
    <input type={type} className={cn(inputVariants({ scale }), className)} ref={ref} {...props} />
  )
);

Input.displayName = 'Input';

export default Input;
